// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1_X8I","cls2":"AuthorHeader-cls2_xvv AuthorHeader-cls1_X8I"};